import { type ISocketOrderEvent } from '@/types/ISocketOrderEvent';

/**
 * Определяет, является ли событие `candidate` более новым, чем `current`.
 * Сокеты могут приходить не по порядку, поэтому порядок определяем по
 * `datetime`, а при равном `datetime` — по `data.id` (большее значение новее).
 * Дубликаты (совпадение `datetime` и `id`) новее не считаются.
 *
 * @param candidate - проверяемое событие
 * @param current - последнее уже обработанное событие (или `null`, если его ещё нет)
 * @returns `true`, если `candidate` нужно применить как более новое
 */
export const isNewerOrderEvent = (
  candidate: ISocketOrderEvent,
  current: ISocketOrderEvent | null
): boolean => {
  if (current === null) {
    return true;
  }

  if (candidate.datetime !== current.datetime) {
    return candidate.datetime > current.datetime;
  }

  return candidate.data.id > current.data.id;
};
